// ------------------------------------------
// お知らせのカテゴリータブ
// ------------------------------------------
class NewsTab {
  constructor(el, opt) {
    this.items = document.querySelectorAll('.' + el);
    if (this.items.length > 0) {
      this.event();
    }
  }

  event() {
    this.items.forEach((item) => {
      const tabs = Array.from(item.querySelectorAll('[role="tab"]'));

      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this.select(tabs, tab));

        // 矢印キーで隣のタブへ移動する(WAI-ARIAのタブの操作)
        tab.addEventListener('keydown', (e) => {
          const keys = { ArrowRight: i + 1, ArrowLeft: i - 1, Home: 0, End: tabs.length - 1 };
          if (!(e.key in keys)) return;
          e.preventDefault();
          const next = tabs[(keys[e.key] + tabs.length) % tabs.length];
          this.select(tabs, next);
          next.focus();
        });
      });
    });
  }

  select(tabs, current) {
    tabs.forEach((tab) => {
      const isCurrent = tab === current;
      tab.classList.toggle('is-active', isCurrent);
      tab.setAttribute('aria-selected', isCurrent ? 'true' : 'false');
      tab.tabIndex = isCurrent ? 0 : -1;
      document.getElementById(tab.getAttribute('aria-controls')).hidden = !isCurrent;
    });
  }
}
